
import { storage } from '../lib/storage';
import { CoinTransaction } from '../types';

export const loyaltyService = {
  COIN_VALUE: 0.1, // 1 Coin = $0.1
  EARN_RATE: 0.1,  // Earn 1 coin for every $10 spent (approx 1% cashback in coins)

  calculateEarnedCoins: (amount: number): number => {
    return Math.floor(amount * loyaltyService.EARN_RATE);
  },

  calculateRedemptionValue: (coins: number): number => {
    return coins * loyaltyService.COIN_VALUE;
  },

  addTransaction: (userId: string, amount: number, type: CoinTransaction['type'], description: string, orderId?: string) => {
    const tx: CoinTransaction = {
      id: 'TX-' + Math.random().toString(36).substr(2, 9),
      userId,
      amount,
      type,
      description,
      orderId,
      timestamp: new Date().toISOString()
    };
    storage.saveCoinTransaction(tx);
  }
};
